import { Injectable } from '@angular/core';
import axios from 'axios';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor {
  constructor(private authService: AuthService) {
    this.initializeRequestInterceptor();
  }

  private initializeRequestInterceptor() {
    axios.interceptors.request.use(
      (config) => {
        const loginState = this.authService.validateLogin();
        if (!loginState) {
          return Promise.reject(new Error('You are not authorized to perform this action. Please contact admin.'));
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }
}
